import React from 'react';
import PropTypes from 'prop-types';

import './ChangedToastMessage.scss';

export function ChangedToastMessageTitle({ title }) {
  return <div className="changed-toast-message__title">{title}</div>;
}

ChangedToastMessageTitle.propTypes = {
  title: PropTypes.node,
};

export function ChangedToastMessageContent({ content }) {
  return <div className="changed-toast-message__content">{content}</div>;
}

ChangedToastMessageContent.propTypes = {
  content: PropTypes.node,
};
